module.exports = __webpack_public_path__ + "img/clock-blue.6a701b71.svg";